import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
var _hoisted_1 = {
  "class": "dashboard fs_box_wrapper"
};
var _hoisted_2 = {
  "class": "fs_box fs_dashboard_box fs_box_narrow"
};
var _hoisted_3 = {
  "class": "fs_box_header",
  style: {
    "padding": "20px 15px",
    "font-size": "16px"
  }
};
var _hoisted_4 = {
  "class": "fs_box_body fs_padded_20"
};
var _hoisted_5 = {
  key: 0,
  "class": "fs_integration_form"
};
var _hoisted_6 = {
  "class": "text-align-right"
};
var _hoisted_7 = {
  key: 1
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item");
  var _component_el_breadcrumb = _resolveComponent("el-breadcrumb");
  var _component_el_input = _resolveComponent("el-input");
  var _component_el_form_item = _resolveComponent("el-form-item");
  var _component_el_button = _resolveComponent("el-button");
  var _component_el_form = _resolveComponent("el-form");
  var _component_el_skeleton = _resolveComponent("el-skeleton");
  var _directive_loading = _resolveDirective("loading");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_el_breadcrumb, {
    separator: "/"
  }, {
    "default": _withCtx(function () {
      return [_createVNode(_component_el_breadcrumb_item, {
        to: {
          name: 'integrations'
        }
      }, {
        "default": _withCtx(function () {
          return _cache[2] || (_cache[2] = [_createTextVNode("API Integrations")]);
        }),
        _: 1 /* STABLE */
      }), _createVNode(_component_el_breadcrumb_item, null, {
        "default": _withCtx(function () {
          return _cache[3] || (_cache[3] = [_createTextVNode("New Integration")]);
        }),
        _: 1 /* STABLE */
      })];
    }),
    _: 1 /* STABLE */
  })]), _createElementVNode("div", _hoisted_4, [!$data.loading ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createVNode(_component_el_form, {
    "label-position": "top",
    data: $data.settings
  }, {
    "default": _withCtx(function () {
      return [_createVNode(_component_el_form_item, {
        label: "ThriveCart API Key"
      }, {
        "default": _withCtx(function () {
          return [_createVNode(_component_el_input, {
            placeholder: "ThriveCart API Key",
            type: "password",
            modelValue: $data.settings.api_key,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
              return $data.settings.api_key = $event;
            })
          }, null, 8 /* PROPS */, ["modelValue"]), _cache[4] || (_cache[4] = _createElementVNode("p", null, "You can find the ThriveCart API Key from Account > Settings > API & Webhooks", -1 /* HOISTED */))];
        }),
        _: 1 /* STABLE */
      }), _createElementVNode("div", _hoisted_6, [_withDirectives((_openBlock(), _createBlock(_component_el_button, {
        onClick: _cache[1] || (_cache[1] = function ($event) {
          return $options.validateKey();
        }),
        type: "primary"
      }, {
        "default": _withCtx(function () {
          return _cache[5] || (_cache[5] = [_createTextVNode("Next")]);
        }),
        _: 1 /* STABLE */
      })), [[_directive_loading, $data.validating]])])];
    }),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["data"])])) : (_openBlock(), _createElementBlock("div", _hoisted_7, [_createVNode(_component_el_skeleton, {
    rows: 3,
    animated: ""
  })]))])])]);
}